const columns = [
  {
    dataField: '_id',
    text: 'Location ID',
    localizationSlug: 'LOCATION_ID',
    type: 'entity',
    entityType: 'location',
    sort: true,
    headerStyle: {
      width: '8%',
    },
  },
  {
    dataField: '_sub_type',
    text: 'Type',
    localizationSlug: 'TYPE',
    sort: true,
    headerStyle: {
      width: '8%',
    },
  },
  {
    dataField: 'name',
    text: 'Name',
    localizationSlug: 'NAME',
    sort: true,
    headerStyle: {
      width: '15%',
    },
  },
  {
    dataField: 'address',
    text: 'Address',
    localizationSlug: 'ADDRESS',
    sort: true,
    headerStyle: {
      width: '35%',
    },
  },
  {
    dataField: 'market.code',
    text: 'Market',
    localizationSlug: 'MARKET',
    titleize: true,
    count: 1,
    sort: true,
    headerStyle: {
      width: '8%',
    },
  },
  {
    dataField: '',
    text: 'Actions',
    localizationSlug: 'ACTIONS',
    type: 'customActions',
  },
];

export default {
  columns,
};
